import { Layout } from "antd";
import React, { useEffect, useState } from "react";
import NavigationBar from "../../components/header/navigationBar";
import { Sidebar } from "../../components/sidebar/sidebar";
import { Outlet } from "react-router-dom";
import Breadcrumbs from "../../components/header/breadCrumb";
import Spinner from "../../components/loader/spinner";
import { getUserStatus } from "../../server/authServer";
import { useAppContext } from "../../contexts/appContext";
import { isAuthenticated } from "../../utils/auth";

function Home() {
  const [collapsed, setCollapsed] = useState(false);
  const { user, setUser } = useAppContext();

  const userValidate = () => {
    getUserStatus().then((res) => {
      setUser(res.data);
    });
  };

  useEffect(() => {
    if (!user && isAuthenticated()) {
      userValidate();
    }
  }, [user]);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} />
      <Layout>
        <NavigationBar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout>
          <Spinner />
          <div className="container">
            <Breadcrumbs />
            <Outlet />
          </div>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default Home;
